export default __webpack_public_path__ + "static/media/test4-slots.f2edb696.png";